import { create } from 'zustand'
import { AutoPlayOptionType } from '../index'

export interface IAutoStore {
  isEnabledPanel: boolean
  isPlaying: boolean
  current: AutoPlayOptionType
}

export const useAutoPlayStore = create<IAutoStore>(() => ({
  isEnabledPanel: false,
  isPlaying: false,
  current: 0,
}))
